import { useMutation } from '@tanstack/react-query';
import { errorMessage } from '../../services/errors';
import { connectorAddress, exportMyData } from '../../services/export';
import { outlineButton } from '../../components/styles';

/**
 * Settings' "Export my data" (CER-70): two files, saved by the browser, that
 * can be read without Cerebro Diem; and how to have a computer of your own
 * save the same two files every night.
 */
export default function ExportData() {
  const save = useMutation({ mutationFn: exportMyData });
  // The command for this Cerebro Diem, whoever is signed in and wherever it runs: only the folder is theirs to fill in.
  const command = `CEREBRO_CONNECTOR_URL=${connectorAddress()} tools/connector/bin/schedule-backup.sh --out "/absolute/folder"`;
  return (
    <div className="space-y-3">
      <p className="text-sm text-on-surface-variant">
        Everything you have made here: tasks, notes, projects, areas, people and every capture. You get two files: a complete copy (JSON)
        and one you can read (Markdown).
      </p>
      <button type="button" onClick={() => save.mutate()} disabled={save.isPending} className={outlineButton}>
        {save.isPending ? 'Exporting…' : 'Export my data'}
      </button>
      {save.isSuccess && <p className="text-sm text-success">Saved {save.data.join(' and ')} to your downloads.</p>}
      {save.isError && <p className="text-sm text-error">Not exported: {errorMessage(save.error)}</p>}

      <details className="text-sm">
        <summary className="cursor-pointer font-medium">Save a copy every night on your own computer</summary>
        <div className="mt-2 space-y-2 text-on-surface-variant">
          <p>
            A small program on a Windows computer of yours (run from WSL) saves the same two files into a folder you choose, once a night.
            It needs Node 20 or later and the Cerebro Diem code. Run this there, with your own folder in place of the example:
          </p>
          <pre aria-label="Nightly backup command" className="overflow-x-auto rounded-xl bg-surface-variant/40 p-3 text-xs text-on-surface">
            {command}
          </pre>
          <p>
            It shows a code: enter it under Connectors above and approve it. It then saves today's files, so you see it work, and sets the
            nightly time (03:00 unless you add <code>--at HH:MM</code>).
          </p>
        </div>
      </details>
    </div>
  );
}
